// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_RQl","cls2":"CiterightInline-cls2_45O CiterightInline-cls1_RQl"};